import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AnalyticsRouteTracker from "./components/AnalyticsRouteTracker";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";

import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import WhatWeMake from "./pages/WhatWeMake";
import HowItWorks from "./pages/HowItWorks";
import QuoteRequest from "./pages/QuoteRequest";
import QuoteCheckout from "./pages/QuoteCheckout";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Privacy from "./pages/Privacy";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import AdminShell from "./components/admin/AdminShell";
import AdminGallery from "./pages/AdminGallery";
import Events from "./pages/Events";
import AdminEvents from "./pages/AdminEvents";
import SocialAccounts from "./pages/SocialAccounts";
import CampaignManager from "./pages/CampaignManager";
import AdminInventory from "./pages/AdminInventory";
import AdminShipping from "./pages/AdminShipping";
import Cart from "./pages/Cart";
import { CartProvider } from "./context/CartContext";

function Layout({ children }) {
  return (
    <div className="workshop-site min-h-screen flex flex-col text-[#F5F0E6]">
      <Navbar />
      <div className="h-20 shrink-0" aria-hidden="true" />
      <main className="workshop-main flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
      <BrowserRouter>
        <AnalyticsRouteTracker />
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#1d2428",
              border: "1px solid rgba(38,198,213,0.25)",
              color: "#F5F0E6",
              boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
          <Route path="/what-we-make" element={<Layout><WhatWeMake /></Layout>} />
          <Route path="/process" element={<Layout><HowItWorks /></Layout>} />
          <Route path="/quote" element={<Layout><QuoteRequest /></Layout>} />
          <Route path="/quote/checkout" element={<Layout><QuoteCheckout /></Layout>} />
          <Route path="/cart" element={<Layout><Cart /></Layout>} />
          <Route path="/events" element={<Layout><Events /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/faq" element={<Layout><FAQ /></Layout>} />
          <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
          <Route path="/login" element={<Layout><Login /></Layout>} />
          <Route path="/admin/login" element={<Layout><Login redirectTo="/admin" /></Layout>} />
          <Route path="/admin" element={<ProtectedRoute><AdminShell><Admin /></AdminShell></ProtectedRoute>} />
          <Route path="/admin/gallery" element={<ProtectedRoute><AdminShell><AdminGallery /></AdminShell></ProtectedRoute>} />
          <Route path="/admin/events" element={<ProtectedRoute><AdminShell><AdminEvents /></AdminShell></ProtectedRoute>} />
          <Route path="/admin/inventory" element={<ProtectedRoute><AdminShell><AdminInventory /></AdminShell></ProtectedRoute>} />
          <Route path="/admin/shipping" element={<ProtectedRoute><AdminShell><AdminShipping /></AdminShell></ProtectedRoute>} />
          <Route path="/admin/settings/social-accounts" element={<ProtectedRoute><AdminShell><SocialAccounts /></AdminShell></ProtectedRoute>} />
          <Route path="/admin/campaigns" element={<ProtectedRoute><AdminShell><CampaignManager /></AdminShell></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
